import React from 'react';
import { StyleSheet, css } from 'aphrodite'

import PortfolioItem from '../../Utilities/PortfolioItem'
import AppDevelopment from './AppDevelopment'
//Images
import TenaTurismImg from '../../../assets/portfolio/AppDevelopment/TenaTurismImg.png'
import LemonEventGuideImg from '../../../assets/portfolio/AppDevelopment/LemonEventGuide.png'
import WhatsappNearby from '../../../assets/portfolio/AppDevelopment/WhatsappNearby.png'
import AlpogoImg from '../../../assets/portfolio/AppDevelopment/Alpogo.png'
import MixxtailImg from '../../../assets/portfolio/AppDevelopment/Mixxtail.png'
import LittleWarImg from '../../../assets/portfolio/AppDevelopment/LittleWar.png'
import NewMetaNotebook from '../../../assets/portfolio/AppDevelopment/NewMetaNotebook.png'
import WiseUpImg from '../../../assets/portfolio/AppDevelopment/WiseUpImg.png'
import AutocheckSystemImg from '../../../assets/portfolio/AppDevelopment/AutocheckSystem.png'




// export default class IndexAppDevelopment extends React.Component{
//  render(){
//   return(
//     <section className={css(styles.MainContainer)}>
//      <div className={css(styles.MainDiv)}>
//      <h1>asdasd</h1>
//      </div>
//     </section>
//   );
//  }
// }
export default class IndexAppDevelopment extends React.Component{
 render(){
  return(
    <section id="AppDevelopment" className={css(styles.MainContainer)}>
     <div className={css(styles.MainDiv)}>
   		<AppDevelopment />
      <PortfolioItem colorTitle="#4D88FF" colorSubtitle="#595959" colorText="#595959" height="220px" rowDirection="" alignText="right" alignImg="left" img={LittleWarImg} title="Little War Online" subtitle="Cross Platfrom MMORPG" text="http://littlewaronline.com/"/>
      <PortfolioItem colorTitle="#4D88FF" colorSubtitle="#595959" colorText="#595959" height="220px" rowDirection="row-reverse" alignText="left" alignImg="right" img={MixxtailImg} title="Mixxtail" subtitle="Wheel of Fortune" text="https://vimeo.com/197323170"/>
      <PortfolioItem colorTitle="#4D88FF" colorSubtitle="#595959" colorText="#595959" height="300px" rowDirection="" alignText="right" alignImg="center" img={AlpogoImg} title="Alpogo" subtitle="Access Control System" text="http://www.alpogo.com/"/>
      <PortfolioItem colorTitle="#4D88FF" colorSubtitle="#595959" colorText="#595959" height="300px" rowDirection="row-reverse" alignText="left" alignImg="center" img={WhatsappNearby} title="WhatsUp Nearby" subtitle="Social Network" text="http://www.apkpure.com/whatsup-nearby"/>
      <PortfolioItem colorTitle="#4D88FF" colorSubtitle="#595959" colorText="#595959" height="300px" rowDirection="" alignText="right" alignImg="center" img={LemonEventGuideImg} title="Lemon Event Guide" subtitle="Custom crafted event guides" text="http://bit.ly/2M29O9c"/>
      <PortfolioItem colorTitle="#4D88FF" colorSubtitle="#595959" colorText="#595959" height="300px" rowDirection="row-reverse" alignText="left" alignImg="center" img={TenaTurismImg} title="TenaTurismo" subtitle="Tourism platform" text="http://www.tenaturismo.gob.e"/>
      <PortfolioItem colorTitle="#4D88FF" colorSubtitle="#595959" colorText="#595959" height="220px" rowDirection="" alignText="right" alignImg="left" img={NewMetaNotebook} title="New Meta" subtitle="Sports Marketplace" text="http://app.newmeta.com.ar"/>
      <PortfolioItem colorTitle="#4D88FF" colorSubtitle="#595959" colorText="#595959" height="220px" rowDirection="row-reverse" alignText="left" alignImg="right" img={WiseUpImg} title="Wise Up" subtitle="English Learning Platform" text="http://www.wiseup.com.ar/"/>
      <PortfolioItem colorTitle="#4D88FF" colorSubtitle="#595959" colorText="#595959" height="220px" rowDirection="" alignText="right" alignImg="left" img={AutocheckSystemImg} title="Autocheck System" subtitle="Advanced Workshop platform" text="http://autochecksystem.com/"/>
     </div>
    </section>
  );
 }
}

const styles = StyleSheet.create({
  MainContainer : {
   margin: '8em auto 0',
   maxWidth: 850,
   '@media (max-width: 960px)' :{
      textAlign: 'center'
   },
  },
	MainDiv : {
		margin: '0 auto',
		'@media (max-width: 960px)' :{
      textAlign: 'center'
		},
	}
})


// WEBPACK FOOTER //
// ./src/Components/Portfolio/AppDevelopment/IndexAppDevelopment.js